// extracted by mini-css-extract-plugin
export const serviceRow = "ServiceRow-module--service-row--24LHm";
export const card = "ServiceRow-module--card--2X1cJ";
export const variantLeft = "ServiceRow-module--variant-left--2H8Kt";
export const withFooter = "ServiceRow-module--with-footer--1x9eW";
export const backgroundWhite = "ServiceRow-module--background-white--30nXS";
export const backgroundGray = "ServiceRow-module--background-gray--2pRdO";
export const tagline = "ServiceRow-module--tagline--20bWb";
export const title = "ServiceRow-module--title--Ws8cO";
export const content = "ServiceRow-module--content--37LLv";
export const images = "ServiceRow-module--images--22tEj";
export const footer = "ServiceRow-module--footer--3wxSH";